import React,{useState,useEffect} from 'react';
import {connect} from 'react-redux';
import M from 'materialize-css/dist/js/materialize.min.js';
import './toast.css';
import {updatePassword,logout} from '../store/authActions';
import {Base64} from 'js-base64';

const invalidPassword = (str) => {
  return str.includes('\\') || str.includes("'")
};

const checkPassword = (str) => {
  //const re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{12,}$/;
  const re = /^(?=.*\d)(?=.*[~`!@#$%^&*()_+-={}|:;"<>,.?/[\]])(?=.*[a-z])(?=.*[A-Z]).{12,}$/;
  return re.test(str);
}

const PasswordChange = ({userid,updatePassword,passwdUpdated,passwdError,logout}) => {
  const [passwd, setPasswd] = useState({pass1:'',pass2:''});
  const {pass1,pass2} = passwd;

  useEffect(()=>{
    if(passwdError){
      setTimeout(()=>logout(),10000);
    }
  //eslint-disable-next-line
  },[passwdError]);

  const onChange = (e) => setPasswd({...passwd, [e.target.name]: e.target.value})
  const onSubmit = (e) => {
    e.preventDefault();
    if(invalidPassword(pass1)){
      M.toast({html: `password cannot contain ' or \\`, classes: 'red darken-2', displayLength: 5000});
      setPasswd({pass1:'',pass2:''});
    }else if(!checkPassword(pass1)){
      M.toast({html: `password requirement not met`, classes: 'red darken-2', displayLength: 5000});
      setPasswd({pass1:'',pass2:''});
    }else if(pass1!==pass2){
      M.toast({html: `passwords do not match`, classes: 'red darken-2', displayLength: 5000});
      setPasswd({pass1:'',pass2:''});
    }else{
      updatePassword({newpass:Base64.encode(pass1)});
    }
  }

  return (
    <>
      <div style={{'margin':'50px 0px 50px 0px'}}></div>
      <div className='container form-container'>
        { !passwdUpdated && !passwdError &&
          <form onSubmit={onSubmit}>
            <ul className='collection' >
              <div className='collection-item light-blue lighten-5'>
                Password requirement:
              </div>
              <div className='collection-item light-blue lighten-5'>
                Minimum 12 characters with upper and lower case letters,<br/>
                numbers, and special characters excluding <strong>single quote '</strong> and <strong>backslash \</strong>
              </div>
              <div className='collection-item light-blue lighten-5'>
                Tip: use a sentence that is easy to remember. For example: <br/>
                todayIsAGreatDay2compute!  
              </div>
            </ul>
            <div className='form-group'>
              <label htmlFor='pass1'>New password</label>
              <input type='password' name='pass1' value={pass1} onChange={onChange} required />
            </div>
            <div className='form-group'>
              <label htmlFor='pass2'>Verify password</label>
              <input type='password' name='pass2' value={pass2} onChange={onChange} required />
            </div>
            <input type='submit' value='update' className='btn btn-primary btn-block' />
          </form>
        }
        { passwdUpdated && !passwdError &&
          <div>Password update request is being processed.</div>
        }
        { passwdError &&
          <div>Authentication token expired. Logging out in 10 seconds</div>
        }
      </div>
    </>
  );
};

const mapStoreToProps = state => ({
  userid: state.auth.userid,
  passwdUpdated: state.auth.passwdUpdated,
  passwdError: state.auth.passwdError
});

export default connect(mapStoreToProps,{updatePassword,logout})(PasswordChange);
